// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "portfolio" + "." + "3f6b2d9f" + ".css";
};